/* Bayou Beignet: one-time, section-specific delight moments.
   IntersectionObserver keeps the work off the scroll path, and the
   entire layer resolves immediately for reduced-motion visitors. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var initialized = new WeakSet();
  var zones = [
    {
      root: '.bb-steps',
      pieces: '.bb-steps__header, .bb-step'
    },
    {
      root: '.bb-spotlight',
      pieces: '.bb-spotlight__media, .bb-spotlight__content'
    },
    {
      root: '.bb-reviews',
      pieces: '.bb-reviews__header, .bb-review-card'
    },
    {
      root: '.bb-benefits',
      pieces: '.bb-puff-anatomy__art, .bb-puff-anatomy__copy, .bb-benefit-card'
    },
    {
      root: '.bb-bundle',
      pieces: '.bb-bundle__eyebrow, .bb-bundle__title, .bb-bundle-card'
    },
    {
      root: '.bb-stockists',
      pieces: '.bb-stockists__eyebrow, .bb-stockists__title, .bb-stockist-sign, .bb-stockists__cta'
    },
    {
      root: '.bb-newsletter',
      pieces: '.bb-newsletter__ticket'
    },
    {
      root: '.bb-contact-page',
      pieces: '.bb-contact__visual, .bb-contact__letter'
    },
    {
      root: '.bb-cart-page',
      pieces: '.bb-cart__masthead, .bb-cart-meter, .cart__items, .bb-empty-cart__art, .bb-empty-cart__content'
    },
    {
      root: '#main-cart-footer',
      pieces: '.bb-cart-summary__intro, .cart__blocks'
    }
  ];
  var tagGroups = [
    { root: '.bb-spotlight__trust', tags: 'li' },
    { root: '.bb-pdp__proofline', tags: 'li' },
    { root: '.bb-about-hero__trust', tags: 'li' },
    { root: '.bb-recipe__meta', tags: 'li' },
    { root: '.bb-puff-anatomy__callouts', tags: '.bb-puff-anatomy__callout' },
    { root: '.bb-bundle__grid', tags: '.bb-bundle-card__badge, .bb-bundle-card__savings' },
    { root: '.bb-steps__grid', tags: '.bb-step__number' },
    { root: '.bb-footer__brand', tags: '.bb-footer__hashtag' },
    { root: '.bb-contact__topics', tags: 'li' },
    { root: '.bb-cart__trust', tags: 'li' }
  ];
  var tagInitialized = new WeakSet();

  var observer = 'IntersectionObserver' in window && !reduce.matches
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-delighted');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 })
    : null;
  var tagObserver = 'IntersectionObserver' in window && !reduce.matches
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-tagged');
          tagObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.18 })
    : null;

  function prepare(root, pieceSelector) {
    if (initialized.has(root)) return;
    initialized.add(root);

    var pieces = root.querySelectorAll(pieceSelector);
    pieces.forEach(function (piece, index) {
      piece.setAttribute('data-bb-delight-piece', '');
      piece.style.setProperty('--bb-delight-delay', (index * 72) + 'ms');
    });

    root.classList.add('bb-delight-ready');

    if (observer) observer.observe(root);
    else root.classList.add('is-delighted');
  }

  function prepareTagGroup(root, tagSelector) {
    if (tagInitialized.has(root)) return;
    tagInitialized.add(root);

    root.querySelectorAll(tagSelector).forEach(function (tag, index) {
      tag.setAttribute('data-bb-paper-tag', '');
      tag.style.setProperty('--bb-tag-delay', (index * 86) + 'ms');
      tag.style.setProperty('--bb-tag-entry-x', ((index % 3) - 1) * 8 + 'px');
      tag.style.setProperty('--bb-tag-entry-rotate', (index % 2 ? 8 : -8) + 'deg');
    });

    root.classList.add('bb-paper-tags-ready');

    if (tagObserver) tagObserver.observe(root);
    else root.classList.add('is-tagged');
  }

  function init(scope) {
    zones.forEach(function (zone) {
      scope.querySelectorAll(zone.root).forEach(function (root) {
        prepare(root, zone.pieces);
      });
    });

    tagGroups.forEach(function (group) {
      scope.querySelectorAll(group.root).forEach(function (root) {
        prepareTagGroup(root, group.tags);
      });
    });
  }

  function revealAll() {
    document.querySelectorAll('.bb-delight-ready').forEach(function (root) {
      root.classList.add('is-delighted');
      if (observer) observer.unobserve(root);
    });

    document.querySelectorAll('.bb-paper-tags-ready').forEach(function (root) {
      root.classList.add('is-tagged');
      if (tagObserver) tagObserver.unobserve(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (reduce.addEventListener) {
    reduce.addEventListener('change', function (event) {
      if (event.matches) revealAll();
    });
  }
})();
